import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyTrashedSpacesPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TrashedSpacesContainer" */ '../src/TrashedSpaces/TrashedSpacesPage.tsx'
			)
		).TrashedSpacesPage,
});
